/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import type { TestSendEmail } from 'src/components/types/types';
import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAlllisttrigger = async (
    clientId?: number,
    pageNumber?: number,
    perPage?: number,
    typeId?: number,
    listTriggerId?: number,
    listTriggerName?: string,
    campaignName?: string,
    status?: number
) => {
    const params = new URLSearchParams();
    if (clientId != null && !isNaN(clientId) && clientId !== 0) {
        params.append('clientId', String(clientId));
    }
    if (pageNumber != null) params.append('pageNumber', String(pageNumber));
    if (perPage != null) params.append('perPage', String(perPage));
    if (typeId != null) params.append('typeId', String(typeId));
    if (listTriggerId != null) params.append('listTriggerId', String(listTriggerId));
    if (listTriggerName != null && listTriggerName.trim() !== '') params.append('listTriggerName', listTriggerName.trim());
    if (campaignName != null && campaignName.trim() !== '') params.append('campaignName', campaignName.trim());
    if (status != null) params.append('status', String(status));
    const query = params.toString();
    const url = `/listtrigger/all${query ? `?${query}` : ''}`;
    const response = await http.get(url);
    return response;
}


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const addlisttrigger = async (formData: FormData) => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            // Add any other required headers your API needs
        }
    };
    
    try {
        const response = await http.post(`/listtrigger/add`, formData, config);
        return response;
    } catch (error) {
        throw error;
    }
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const deletelisttrigger= async (data: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const response = http.delete(`/listtrigger/delete`, {data: data})
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const updatestatus = async (data: any) => {
    const response = http.patch(`listtrigger/activate`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const updatelisttrigger = async (formData: FormData) => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    
    try {
        const response = await http.put(`/listtrigger/update`, formData, config);
        return response;
    } catch (error) {
        throw error;
    }
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const copylisttrigger = async (id: number, createdBy: number) => {
    const response = await http.post(`/listtrigger/copy?id=${id}&createdBy=${createdBy}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const getlisttriggerById = async (id: string) => {
    const response = http.get(`/listtrigger/${id}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const updatePauseResumeStatus = async (data: any) => {
    const response = http.patch(`listtrigger/pause`, data)
    return response;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const sendTestEmail = async (data: TestSendEmail) => {
    const response = await http.post(`/testemail/send`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const getTriggerReportData = async (id: any, fromDate?: any, toDate?: any, Status?: any) => {
    if(fromDate && toDate) {
        const response = await http.get(`/listtrigger/report/download/${id}?fromDate=${fromDate}&toDate=${toDate}&Status=${Status}`);
        return response;
    }
    const response = await http.get(`/listtrigger/report/download/${id}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getTriggerCustomFieldData = async () => {
    const response = await http.get(`/report/getcustomnpifields`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const exportTriggerStandardReport = async (id: any) => {
    const response = await http.get(`/report/standardnpireportlisttrigger/${id}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const exportTriggerCustomFieldReport = async (data: any) => {
    const response = await http.post(`/report/customnpireportlisttrigger`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getTriggerReportCardCounts = async (id: any, clientId: any, startDate: any, endDate: any, status: any) => {
    const response = await http.get(`/listtrigger/dashboard/cardcounts?clientId=${clientId}&ListTrigId=${id}&fromDate=${startDate}&toDate=${endDate}&status=${status}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getTriggerReportDomainCount = async (id: any, clientId: any, startDate: any, endDate: any, status: any) => {
    const response = await http.get(`/listtrigger/dashboard/domaincounts?clientId=${clientId}&ListTrigId=${id}&fromDate=${startDate}&toDate=${endDate}&status=${status}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getTriggerReportDeviceCount = async (id: any, clientId: any, startDate: any, endDate: any, status: any) => {
    const response = await http.get(`/listtrigger/dashboard/devicecounts?clientId=${clientId}&listTrigId=${id}&fromDate=${startDate}&toDate=${endDate}&status=${status}`);
    return response;
}